import React from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import FadeIn from '../../../../../molecules/Transitions/FadeIn'
import { useStatusTemplateContext } from '../StatusTemplateProvider'
import PersonalSpace from '../../../shared/PersonalSpace'
import { useListStatusTemplateMetadataTypes } from '../../../../../../api/groups'
import MetadataTypeList from './MetadataTypeList'

const useStyles = makeStyles(() => ({
  tabBody: {
    padding: '20px 0'
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    padding: '40px'
  }
}))

function MetadataTab () {
  const classes = useStyles()
  const { statusTemplate } = useStatusTemplateContext()

  const { data: metadataTypes, isLoading } = useListStatusTemplateMetadataTypes(
    statusTemplate?.statusTemplateId
  )

  if (isLoading) {
    return (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <FadeIn>
      <div className={classes.tabBody}>
        <MetadataTypeList
          metadataTypes={metadataTypes || []}
          templateId={statusTemplate.statusTemplateId}
        />
        <PersonalSpace />
      </div>
    </FadeIn>
  )
}

export default MetadataTab
